﻿import mixin from './mixin';
import { useVuelidate } from '@vuelidate/core';
import { required, sameAs } from '@vuelidate/validators';

const passwordApp = {
    setup() {
        return { v$: useVuelidate() }
    },
    mixins: [mixin],
    data() {
        return {
            apiCheckToken: '',
            apiWachtwoord: '',
            loading: true,
            returnUrl: '/',
            token: '',
            tokenValid: true,
            tokenError: '',
            password: '',
            confirmPassword: '',
            passwordChanged: false,
            passwordError: '',
            data: {
                typeAlias: 'Success'
            },
            passwordType: 'password',
            confirmPasswordType: 'password'
        }
    },
    validations() {
        return {
            password: { required },
            confirmPassword: {
                required,
                sameAs: sameAs(this.password)
            }
        }
    },
    methods: {
        togglePassword(type) {
            if (type === 'password') {
                if (this.passwordType === 'password') {
                    this.passwordType = 'text';
                } else {
                    this.passwordType = 'password';
                }
            } else {
                if (this.confirmPasswordType === 'password') {
                    this.confirmPasswordType = 'text';
                } else {
                    this.confirmPasswordType = 'password';
                }
            }
        },
        async checkToken() {
            const response = await this.fetchApiData(this.apiCheckToken, '', 'get');
            if (response.status === 200) {
                this.tokenValid = response.data.success;
                this.tokenError = response.data.errorMessage;
            } else {
                this.tokenValid = false;
            }
            this.loading = false;
        },
        async setPassword() {
            const valid = await this.v$.$validate();
            if (!valid) return
            let data = {
                password: this.password,
                accessToken: this.token
            };
            const response = await this.fetchApiData(this.apiWachtwoord, data, 'post');
            if (response.status === 200) {
                if (response.data.success) {
                    this.passwordChanged = true;
                    this.passwordError = '';
                } else {
                    this.passwordChanged = false;
                    this.passwordError = response.data.errorMessage;
                }
            } else {

            }
        },
        proceed() {
            location.href = this.returnUrl;
        }
    },
    mounted() {
        if (this.$el.dataset.apichecktoken) this.apiCheckToken = this.$el.dataset.apichecktoken;
        if (this.$el.dataset.apiwachtwoord) this.apiWachtwoord = this.$el.dataset.apiwachtwoord;
        if (this.$el.dataset.returnurl) this.returnUrl = this.$el.dataset.returnurl;
        if (this.$el.dataset.token) this.token = this.$el.dataset.token;
        if (this.token !== '') {
            this.checkToken();
        } else {
            this.loading = false;
            this.tokenValid = false;
        }
    }
}

export default passwordApp;
